// extracted by mini-css-extract-plugin
export var modal = "_c2-0";